import React from 'react';
import {useTranslation} from '../../../hooks/useTranslation';

export default function RadioField({
  id,
  label,
  setFields,
  options,
  field,
  readOnly,
}) {
  const {t} = useTranslation();
  return (
    <div className='equipment__container'>
      <div className='equipment__radio'>
        <div className='title'>{label}</div>
        <div
          className='options'
          title={readOnly ? t('createEquipment.readOnly') : undefined}
          style={
            readOnly
              ? {opacity: 0.6, cursor: 'not-allowed', pointerEvents: 'none'}
              : {}
          }
        >
          {options?.map((option, index) => {
            return (
              <div className='option' key={id + index}>
                <input
                  type='radio'
                  id={id + index}
                  name={id}
                  checked={field?.value === option?.value}
                  value={option.value}
                  onChange={e => {
                    if (readOnly) {
                      return;
                    } else {
                      setFields(old => {
                        let data = [
                          ...old.map(item => {
                            let newItem = {...item};
                            if (newItem?.key === id) {
                              newItem.value = e.target.value;
                            }
                            return newItem;
                          }),
                        ];
                        return data;
                      });
                    }
                  }}
                />
                <label htmlFor={id + index}>{option?.label}</label>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
